import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'walden-fast/services/feature-flags';

export default class AppIndexRoute extends Route {
  @service('router') declare routerService: RouterService;
  @service('feature-flags') declare featureFlags: FeatureFlagsService;

  redirect() {
    this.featureFlags
      .isEnabled('WALDEN_DASHBOARD')
      .then((dashboardEnabled) => {
        if (dashboardEnabled) {
          this.routerService.replaceWith('app.dashboard');
        } else {
          this.routerService.replaceWith('app.user.profile');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
